module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-1-750e3b5e0d03ec57a817aee6d1aff07b.webp";